import React, { useState } from "react";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import primg from "../assets/img/ADL_2531-2.jpg";
import { useTranslation } from "react-i18next";

const MotPresident = () => {
  const { t } = useTranslation();
  const ReadMore = ({ children }) => {
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
      setIsReadMore(!isReadMore);
    };
    return (
      <p className="text">
        {isReadMore ? text.slice(0, 1000) : text}
        <button
          onClick={toggleReadMore}
          className="read-or-hide text-zinc-300 hover:text-white"
        >
          {isReadMore ? "...Lire Plus" : " Reduit Le Text"}
        </button>
      </p>
    );
  };
  return (
    <div>
      <div className="bg-gray-50  py-10">
        <AnimationOnScroll animateIn="animate__fadeInLeft" duration={1}>
          <h2 className="text-6xl text-zinc-600 drop-shadow-2xl font-bold text-center">
            {t("Mot Du President")}
          </h2>
        </AnimationOnScroll>
      </div>
      <div className="relative pb-16">
        <div
          className="hidden absolute top-0 inset-x-0 h-1/2 bg-gray-50 lg:block"
          aria-hidden="true"
        />
        <div className="max-w-7xl mx-auto bg-[#8d714a] lg:bg-transparent lg:px-8">
          <div className="lg:grid lg:grid-cols-12">
            <div className="relative z-10 lg:col-start-1 lg:row-start-1 lg:col-span-4 lg:py-16 lg:bg-transparent">
              <div
                className="absolute inset-x-0 h-1/2 bg-gray-50 lg:hidden"
                aria-hidden="true"
              />
              <div className="max-w-md mx-auto px-4 sm:max-w-3xl sm:px-6 lg:max-w-none lg:p-0">
                <div className="aspect-w-10 aspect-h-6 sm:aspect-w-2 sm:aspect-h-1 lg:aspect-w-1">
                  <AnimationOnScroll
                    animateIn="animate__bounceInLeft"
                    duration={2}
                    animateOnce="true"
                  >
                    <img
                      className="object-cover relative object-center rounded-3xl shadow-2xl"
                      src={primg}
                      alt=""
                    />
                  </AnimationOnScroll>
                </div>
              </div>
            </div>
            <div className="relative bg-[#8d714a] lg:col-start-3 lg:row-start-1 lg:col-span-10 lg:rounded-3xl lg:grid lg:grid-cols-10 lg:items-center">
              <div
                className="hidden absolute inset-0 overflow-hidden rounded-3xl lg:block"
                aria-hidden="true"
              >
                <svg
                  className="absolute bottom-full left-full transform translate-y-1/3 -translate-x-2/3 xl:bottom-auto xl:top-0 xl:translate-y-0"
                  width={404}
                  height={384}
                  fill="none"
                  viewBox="0 0 404 384"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                      x={0}
                      y={0}
                      width={20}
                      height={20}
                      patternUnits="userSpaceOnUse"
                    >
                      <rect
                        x={0}
                        y={0}
                        width={4}
                        height={4}
                        className="text-yellow-900"
                        fill="currentColor"
                      />
                    </pattern>
                  </defs>
                  <rect
                    width={404}
                    height={384}
                    fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
                  />
                </svg>
                <svg
                  className="absolute top-full transform -translate-y-1/3 -translate-x-1/3 xl:-translate-y-1/2"
                  width={404}
                  height={384}
                  fill="none"
                  viewBox="0 0 404 384"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                      x={0}
                      y={0}
                      width={20}
                      height={20}
                      patternUnits="userSpaceOnUse"
                    >
                      <rect
                        x={0}
                        y={0}
                        width={4}
                        height={4}
                        className="text-white"
                        fill="currentColor"
                      />
                    </pattern>
                  </defs>
                  <rect
                    width={404}
                    height={384}
                    fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d) "
                    className="text-white"
                  />
                </svg>
              </div>
              <div className="relative max-w-md mx-auto py-12 px-4 space-y-6 sm:max-w-3xl sm:py-16 sm:px-6 lg:max-w-none lg:p-0 lg:col-start-4 lg:col-span-6">
                <h2
                  className="text-3xl pt-8 font-extrabold text-white"
                  id="join-heading"
                >
                  {t("Prof Mohcine Boufettal")}
                </h2>
                <p className="text-md pb-8 text-gray-100">
                  <ReadMore>
                    {t(
                      "Quatrième Art, est une association à but non lucratif, fondée le 14 Décembre 2015, par un ensemble de musiciens, intellectuels et mélomanes. Son objectif est de promouvoir l’art de la Musique, dans tous ses aspects; authentique et contemporaine. Elle déploie des efforts pour enseigner la musique et donner des prestations à la hauteur de l’art musical. Depuis sa création, l’Association Quatrième Art participe à la promotion de l’art musical à travers le don de cours de musique, de solfège et d’instruments de de façon hebdomadaire. L’association se fixe pour objectif le développement de toute initiative susceptible de rapprocher les acteurs professionnels et particuliers, institutionnels et collectivités, associations et milieux économiques, qui œuvrent dans le domaine de la sauvegarde, de la réhabilitation, de l’entretien, de la valorisation du patrimoine musical, sous toutes ses composantes, ainsi que de son animation culturelle, artistique et touristique. Dans ce but, l’association quatrième art entreprend des actions consistant à organiser des journées d’études thématiques et des rencontres, ouvertes aux professionnels, aux chercheurs, aux enseignants, et plus généralement à toute personne intéressée par sa démarche, afin d’échanger des expériences et de faciliter le dialogue entre les acteurs et développer les contacts entre les acteurs du domaine culturel dans la finalité de nouer des relations avec des organisations ayant des buts similaires au niveau interrégional et international. Conçue comme un relais au service du patrimoine, l’association quatrième art n’a pas pour but de se substituer ni aux acteurs de terrain ni aux institutions, mais de mener des réflexions prospectives sur les façons de mise en valeur de la musique au Maroc et dans le monde. L’association a commémoré la disparition du feu maitre Saïd Chraïbi, par l’organisation de deux grands événements, en mars 2017 et en avril 2018, au complexe Touria Sekkat, à Casablanca, qui a connu un grand succès avec la participation de grands talents luthistes du Royaume. Cet événement a été couvert par la première chaine télévisée marocaine. En partenariat avec l’association les amis du centre psychiatrique universitaire de Casablanca, l’association quatrième art, donne des séances de musicothérapie tous les jeudis matin au centre psychiatrique du CHU Ibn Rochd de Casablanca."
                    )}
                  </ReadMore>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MotPresident;
